(function($, Drupal) {
  Drupal.behaviors.wrap_tables = {
    attach: function(context, settings) {
      $('.text-formatted').once('wrap-tables').each(function() {
        $(this).find('table').each(function() {
          $(this).wrap('<div class="table-wrap"></div>');
        });
        $(this).find('.table-wrap').each(function() {
          $(this).wrap('<div class="table-shadow"></div>');
        });
      });
    }
  };
})(jQuery, Drupal);
